var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCircleLogoFree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#06162D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5356 21.069C29.6 20.7356 29.6 20.3423 29.6 19.9747V19.932C29.554 14.3154 25.6606 10.4 20.2669 10.4C14.6063 10.3915 10.4 14.2897 10.4 20.0004C10.4 25.711 14.5695 29.5922 20.4418 29.5922C23.4714 29.7013 26.4186 28.6613 28.6059 26.7112L26.9308 24.7792C25.2254 26.2664 22.9744 27.0948 20.6351 27.0959C18.8416 27.1676 17.0915 26.5716 15.7731 25.4401C14.4546 24.3086 13.6768 22.7352 13.6123 21.069H29.5356ZM13.6528 18.6754H13.6489V18.701C13.6502 18.6924 13.6515 18.6839 13.6528 18.6754ZM13.6528 18.6754H26.4059C26.0101 15.2302 23.5894 13.0331 20.2023 13.0331C16.53 13.0331 14.1672 15.355 13.6528 18.6754Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLogoFree);
export default __webpack_public_path__ + "static/media/circle_logo_free.73631bdbb1041e74b21b06a8e8a928b5.svg";
export { ForwardRef as ReactComponent };